export default __webpack_public_path__ + "static/media/thumbnail.6825d1b9.jpg";